import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  dialog: {
    "& .MuiDialogActions-root": {
      display: "flex",
      alignItem: "center",
      justifyContent: "flex-start",
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    "& .MuiDialogTitle-root": {
      padding: theme.spacing(1),
      paddingLeft: theme.spacing(3),
    },
  },
  dialogTitle: {
    color: "#37474f",
    maxWidth: "80%",
    "& .MuiTypography-root": {
      color: "#37474f",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  bigModal: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: "90%",
    },
  },
  btn: {
    textTransform: "none",
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
